export default __webpack_public_path__ + "static/media/CNo.30-2.9c069a9d.jpg";